import { render, staticRenderFns } from "./LiteracyAssment.vue?vue&type=template&id=9401353e&scoped=true"
import script from "./LiteracyAssment.vue?vue&type=script&lang=js"
export * from "./LiteracyAssment.vue?vue&type=script&lang=js"
import style0 from "./LiteracyAssment.vue?vue&type=style&index=0&id=9401353e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9401353e",
  null
  
)

export default component.exports